export default "__VITE_ASSET__DAyp$z2___"